// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SORT_COMPLAINTS_SHORT = "Po\u010det nahl\u00e1sen\u00ed";
export const BZ2_SORT_COMPLAINT_TIME_SHORT = "Nahl\u00e1sen\u00e9";
export const BZ2_SORT_CREATION = "Najnov\u0161ie pridan\u00e9";
export const BZ2_SORT_PRICE = "Cena: najlacnej\u0161ie";
export const BZ2_SORT_PRICE_DESC = "Cena: najdrah\u0161ie";
export const BZ2_SORT_SCORE = "Popul\u00e1rne";
export const BZ2_SORT_SCORE_NEW = "Relevantn\u00e9";
export const BZ2_SORT_UPDATED = "Aktualizovan\u00e9";
export const BZ2_SORT_WATCHDOG = "Ulo\u017een\u00e9 h\u013eadanie";
export const BZ2_SORT_WISHLIST = "Ulo\u017een\u00e9";
